export function drawAlarmSummary(pdf, alerts, startY) {
  const margin = 40;
  const rowHeight = 16;

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const usableWidth = pageWidth - margin * 2;

  // Título de sección
  pdf.setFillColor(180, 180, 180);
  pdf.rect(margin, startY, usableWidth, rowHeight, "F");
  pdf.setTextColor(0);
  pdf.setFont("helvetica", "bold");
  pdf.text("Resumen de alarmas", margin + 5, startY + 12);

  let y = startY + rowHeight + 10;

  // Si no hay alarmas, mostramos el texto en lugar de la tabla
  if (!alerts || alerts.length === 0) {
    pdf.setFont("helvetica", "bold");
    pdf.text("El envío no cuenta con alarmas registradas.", margin + 5, y + 12);
    return y + rowHeight + 10;
  }

  // Cálculo de columnas [Punto | Temperatura | Fecha/Hora]
  // Reparto proporcional + mínimos razonables
  const colWidths = [
    40, // Punto
    Math.max(70, usableWidth * 0.2), // Temperatura (ºC)
    Math.max(90, usableWidth * 0.2), // Fecha/Hora
  ];

  const sum = colWidths.reduce((a, b) => a + b, 0);
  if (sum !== usableWidth) {
    colWidths[colWidths.length - 1] += usableWidth - sum;
  }

  const drawCell = (x, y, w, h, text = "") => {
    pdf.rect(x, y, w, h);
    if (text) {
      const tx = x + 5;
      const ty = y + 12;
      const wrapped = pdf.splitTextToSize(String(text), w - 10);
      pdf.text(wrapped, tx, ty);
    }
  };

  const formatData = (v) =>
    typeof v === "number" && isFinite(v) ? v.toFixed(2) : "-";

  // Cabecera
  const drawHeader = () => {
    pdf.setFont("helvetica", "bold");
    let x = margin;
    drawCell(x, y, colWidths[0], rowHeight, "Punto");
    x += colWidths[0];
    drawCell(x, y, colWidths[1], rowHeight, "Temperatura (ºC)");
    x += colWidths[1];
    drawCell(x, y, colWidths[2], rowHeight, "Fecha/Hora");
    y += rowHeight;
  };

  const ensureSpace = () => {
    if (y + rowHeight > pageHeight - margin) {
      pdf.addPage();
      y = margin;
      drawHeader();
      pdf.setFont("helvetica", "normal");
    }
  };

  // Tabla
  drawHeader();
  pdf.setFont("helvetica", "normal");

  alerts.forEach((alert, index) => {
    ensureSpace();

    const punto = `${index + 1}`;
    const temp = formatData(alert?.value);
    const fecha = alert?.date || "-";

    let x = margin;
    drawCell(x, y, colWidths[0], rowHeight, punto);
    x += colWidths[0];
    drawCell(x, y, colWidths[1], rowHeight, temp);
    x += colWidths[1];
    drawCell(x, y, colWidths[2], rowHeight, fecha);

    y += rowHeight;
  });

  return y + 10;
}
